import request from '@/lib/request.mjs';

export default function (clientUuid) {
  return request('getTemporaryRedirect', { client_uuid: clientUuid, forceRefresh: true });
}
